import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Menu from './Menu';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
  showMenu?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, showMenu = true }) => {
  return (
    <div className="app-wrapper">
      {showMenu && <Menu />}
      <div className={`main-wrapper ${showMenu ? 'with-sidebar' : ''}`}>
        <Header />
        <main className="main-content">
          <div className="content-container">
            {children}
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
